import type { SpaceQuota } from '@lighthouse/core'
import type { FC, PropsWithChildren } from 'react'
import React, { createContext, useContext } from 'react'

type SpaceQuotaWithUploadFileLimitSize = Pick<SpaceQuota, 'currentVersion' | 'currentVersionCode'> &
    Partial<Omit<SpaceQuota, 'currentVersion' | 'currentVersionCode'>> & {
        uploadFileLimitSize: number
        spaceId: string
    }

export type SpaceQuotaContextType = {
    quota?: SpaceQuotaWithUploadFileLimitSize
    update?: () => void
}

export const SpaceQuotaContext = createContext<SpaceQuotaContextType>({})

type SpaceQuotaProviderProps = PropsWithChildren<{
    value: SpaceQuotaContextType
}>

export const SpaceQuotaProvider: FC<SpaceQuotaProviderProps> = props => <SpaceQuotaContext.Provider {...props} />

export const useSpaceQuotaContext = () => useContext(SpaceQuotaContext)
